module.exports = {
    config: window.__js_bridge,
    state: {
        svgSymbolsLoaded: false,
        googleRecaptchaLoaded: false,
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/main/config.js